<div class="vehicle-summary-card" [class.selected]="selected" [class.loading]="loading">
  @if (loading) {
    <div class="vehicle-image-shell skeleton-image">
      <p-skeleton shape="circle" size="72px" />
    </div>
    <p-skeleton styleClass="plate-skeleton" width="42%" height="28px" />
    <div class="vehicle-card-footer skeleton-footer">
      <p-skeleton width="104px" height="18px" />
      <p-skeleton width="128px" height="18px" />
    </div>
  } @else {
    @if (selected) {
      <span class="selected-indicator" aria-hidden="true">✓</span>
    }

    <div class="vehicle-image-shell">
      <img [src]="vehicle?.image || 'assets/images/icons/car-icon.svg'" [alt]="imageAlt" class="vehicle-image" />
    </div>

    @if (plateText) {
      <div class="vehicle-license-plate">
        <bdi>{{ plateText }}</bdi>
      </div>
    }

    <div class="vehicle-card-footer">
      @if (hasVehicleSpecs) {
        <div class="vehicle-specs">
          @if (vehicle?.color) {
            <span>{{ vehicle?.color }}</span>
          }
          @if (vehicle?.color && vehicle?.productionYear && vehicle?.productionYear !== 0) {
            <span class="spec-divider" aria-hidden="true">|</span>
          }
          @if (vehicle?.productionYear && vehicle?.productionYear !== 0) {
            <span>{{ vehicle?.productionYear }}</span>
          }
        </div>
      }

      @if (vehicleName) {
        <div class="vehicle-model">
          <img src="assets/images/icons/car-icon.svg" alt="" aria-hidden="true" />
          <span>{{ vehicleName }}</span>
        </div>
      }
    </div>
  }
</div>
